import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { SERVER_URL, BUILD_PLATFORM, PLATFORM_PWA, PLATFORM_ANDROID, PLATFORM_IOS } from '../constants';
import { Divider, Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
// import { downloadCsv, downloadCsvAndroid } from '../helpers/Helpers';
import QuickModal from './QuickModal';
import CampaignIcon from '@mui/icons-material/Campaign';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { formatDateTime } from '../helpers/Helpers';
import EditOfficePost from './EditOfficePost';
import ConfirmDialog from './ConfirmDialog';
import CommonSnackbar from './CommonSnackbar';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(0),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
}));
  
function OfficePosts (props) {
    const [open, setOpen] = React.useState(false);
    const [message, setMessaage] = useState("fetching data...");
    const [quickModalOpen, setQuickModalOpen] = useState(false);
    const [quickModalMessage, setQuickModalMessage] = useState("");
    const [posts, setPosts] = useState([]);

    const dialogContentRef = React.useRef(null);

    const handleClickOpen = () => {
        setOpen(true);
        fetchPosts();
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
        props.fetchOffices();
    };

    const fetchPosts = () => {
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/list-office-posts/' + props.officeId + '/100/desc', {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data.data);
            setPosts(data.data);
            if (data.data.length < 1) setMessaage("No advisories yet");
        })
        .catch(err => console.error(err));
    };

    // 👉 Function you can pass down to children
    const scrollToTop = () => {
        if (dialogContentRef.current) {
            dialogContentRef.current.scrollTop = 0;
            // optional: focus first Box/Card
            const firstBox = dialogContentRef.current.querySelector("div.MuiBox-root");
            if (firstBox) {
                firstBox.focus?.(); // only works if focusable
            }
        }
    };

    const [deleteId, setDeleteId] = useState();
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const onDeleteButtonClick = (id) => {
        // console.log('delete id', id);
        setDeleteId(id);
        setConfirmDeleteOpen(true);
    }
    const handleConfirmDelete = () => {
        // console.log("Delete confirmed");
        deleteOfficePost();
        // deleteContact();
        // handleClose();
    }

    const deleteOfficePost = () => {
        // console.log("deleteId", deleteId);
        // setErrorMessage("Advisory successfully delete");
        // return;
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/delete-office-post',
        {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify({
                "id" : deleteId
            })
        })
        .then(response => response.json())
        .then(data => {
            // console.log("data", data);
            if (data.status == 1) {
                setErrorMessage("Advisory successfully deleted");
                fetchPosts();
            }
            else {
                setErrorMessage("Error deleting Advisory");
            }
        })
        .catch(err => console.error(err))
    };

    const [errorTitle, setErrorTitle] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const snackbar = {
        errorTitle,
        errorMessage,
        setErrorTitle,
        setErrorMessage
    }

    return (
        <React.Fragment>
            <QuickModal 
                quickModalOpen={quickModalOpen}
                quickModalMessage={quickModalMessage}
                setQuickModalOpen={setQuickModalOpen} 
            />
            {props.hideButton ? null :
                <IconButton
                    onClick={handleClickOpen}
                    size="medium"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                >
                    <CampaignIcon fontSize='large' sx={{ color: 'gray' }}/>
                </IconButton>
            }
            
            <BootstrapDialog
                sx={{
                    "& .MuiDialog-container": {
                      "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "500px",
                      },
                    },
                }}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    <Stack direction="column" justifyContent="center" alignItems="flex-start" spacing={0}>
                        <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                            Advisories
                        </Typography>
                        <Typography variant="body1">
                            {props.officeName}
                        </Typography>
                    </Stack>
                </DialogTitle>
                
                <DialogContent 
                    sx={{ p: 1, minHeight: "300px" }} 
                    dividers 
                    ref={dialogContentRef}   // attach ref
                >
                    <CommonSnackbar snackbar={snackbar} />
                    {posts.map(post => {
                    // Extract just the date part from the timestamp
                    const postDate = post.created_at_local.split(" ")[0]; // "2025-12-16"
                    const todayDate = new Date().toISOString().split("T")[0]; // also "YYYY-MM-DD"

                    const isOlderThanToday = postDate !== todayDate;

                    return (
                        <Box key={post.id} sx={{ p:1, display: 'flex', justifyContent: 'center' }}>
                            <Card sx={{ minWidth: 275, backgroundColor: 'background.paper', boxShadow: 6, borderRadius: 2 }}>
                                <CardContent>
                                    <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 13 }}>
                                        posted: {formatDateTime(post.created_at_local)}
                                        {post.created_at_local !== post.updated_at_local ? 
                                            <>
                                                <br />edited: {formatDateTime(post.updated_at_local)}
                                            </>
                                        : null}
                                    </Typography>
                                    <Typography style={{whiteSpace: "pre-line", verticalAlign: "bottom"}} variant="body1" component="div">
                                        {post.content}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <EditOfficePost 
                                        fetchPosts={fetchPosts} 
                                        officeId={props.officeId} 
                                        postId={post.id} 
                                        content={post.content} 
                                        date={post.created_at_local}
                                        scrollToTop={scrollToTop}
                                        disabled={isOlderThanToday}   // disable if not today
                                    /> 
                                    <Button onClick={() => onDeleteButtonClick(post.id)} size="small">Delete</Button>
                                </CardActions>
                            </Card>
                        </Box>
                    );
                })}
 
                    {posts.length < 1 ? 
                        <Box sx={{ p:1, display: 'flex', justifyContent: 'center' }}>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="body2" component="div">{ message }</Typography> 
                        </Box>
                    : null}
                </DialogContent>

                <DialogActions>
                    <EditOfficePost 
                        fetchPosts={fetchPosts} 
                        officeId={props.officeId}
                        scrollToTop={scrollToTop} 
                    /> 
                    <div style={{flex: '1 0 0'}} />
                    <Button autoFocus onClick={handleClose}>
                        Close
                    </Button>
                </DialogActions>
            </BootstrapDialog>

            <ConfirmDialog
                title="Delete Contact"
                open={confirmDeleteOpen}
                setOpen={setConfirmDeleteOpen}
                onConfirm={handleConfirmDelete}
            >
                Are you sure you want to delete this Advisory?
            </ConfirmDialog>
        </React.Fragment>
    );
}

export default OfficePosts;
